import React from 'react';
import { SViagensFlightSearch } from '@smiles-viagens/sviagens-react-package-search';

const envMap = {
  dev: 'develop',
  uat: 'homol',
  hml: 'homol',
  prd: 'production',
} as const;

const getEnvironment = (): typeof envMap[keyof typeof envMap] | 'preprod' => {
  const envPrefix = window.smlsEnv?.slice(0, 3) as keyof typeof envMap | undefined;
  return envPrefix && envMap[envPrefix] ? envMap[envPrefix] : 'preprod';
};

export const SearchPackages = () => {
  const environment = getEnvironment();

  return <SViagensFlightSearch environment={environment} />;
};
